<template>
  <div class="vip-remark">vip-remark</div>
</template>

<script>
  export default {
    name: "VipRemark"
  }
</script>

<style scoped>

</style>